/* !!!!!!!!!!!!!!!!!!!!!! */
/* !!! GENERATED FILE !!! */
/* !!!!!!!!!!!!!!!!!!!!!! */

import {
  ModuleDoneType,
  ModuleType,
  PlaniraPlanImage,
  type PlaniraTemplate,
} from "../../types";
import { PlanType } from "../../types";
import { PlanTemplateType } from "../template_types";

export const FlowFarmersMarketTemplate: PlaniraTemplate = {
  type: PlanTemplateType.FlowFarmersMarket,

  planType: PlanType.Quickstart,
  suggestedTitles: [
    "Fresh Finds Await!",
    "Let’s Support Local!",
    "Market Day Excitement!",
  ],
  title: "Farmers Market Trip",
  description: "Plan a fun trip to the farmers market.",
  longDescription:
    "Gather your friends for a delightful day at the farmers market! Choose a date, decide on what to buy, and plan meals to make with the fresh ingredients!",
  emoji: "🍏",
  titleHelp: "Change title or choose another:",
  imageType: PlaniraPlanImage.Travel,

  sections: [
    {
      section: {
        isExpandable: false,
        isDraggable: false,
      },
      modules: [
        {
          type: ModuleType.PlanInfo,
          doneType: ModuleDoneType.None,
          title: "Farmers Market Trip",
          emoji: "🍏",
        },
      ],
    },
    {
      section: {
        title: "Ongoing",
      },
      modules: [
        {
          type: ModuleType.Calendar,
          doneType: ModuleDoneType.Voting,
          title: "When should we go to the farmers market?",
          emoji: "📅",
          completeAction: {
            question: "Decide on what to buy?",
            description: "What ingredients should we look for at the market?",
            addModules: [
              {
                type: ModuleType.Poll,
                doneType: ModuleDoneType.Voting,
                title: "What items should we buy?",
                emoji: "🥕",
                completeAction: {
                  question: "Decide on meals to make?",
                  description:
                    "What meals should we plan to cook with our fresh ingredients?",
                  addModules: [
                    {
                      type: ModuleType.Poll,
                      doneType: ModuleDoneType.Voting,
                      title: "What meals should we prepare?",
                      emoji: "🍲",
                    },
                  ],
                },
              },
            ],
          },
        },
      ],
    },
  ],

  onTemplateComplete: {
    outroTitle: "Fresh Flavors Await!",
    outroDescription:
      "Your farmers market trip plans are set! Enjoy the fresh produce!",
  },
};
